import { render, staticRenderFns } from "./ViewingRoomArtwork.vue?vue&type=template&id=8c58bd1a&scoped=true"
import script from "./ViewingRoomArtwork.vue?vue&type=script&lang=js"
export * from "./ViewingRoomArtwork.vue?vue&type=script&lang=js"
import style0 from "./ViewingRoomArtwork.vue?vue&type=style&index=0&id=8c58bd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c58bd1a",
  null
  
)

export default component.exports